var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { isUrl } from "../../../urlUtils";
import { styled } from "../../../theme";
import { Button } from "../../../button";
import { Text } from "../../../text";
import { FlexColumn } from "../../../box";
import { SUPPORTED_MEDIA_TYPE_IMAGES } from "../../snapshot-control-field/utils";
import { FileInput } from "../file-input";
import { ReactComponent as CameraPlaceholder } from "./assets/placeholder-camera.svg";
import { getPreSignedUrl } from "../../formHelpers";
import Alert from "react-s-alert";
var ClickDelegate = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: ", ";\n  max-width: Max(30rem, 30em);\n  width: 100%;\n"], ["\n  cursor: ", ";\n  max-width: Max(30rem, 30em);\n  width: 100%;\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "not-allowed" : "pointer");
});
var ClearButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 25px;\n\n  &:hover {\n    transition-delay: 100ms;\n  }\n\n  ", "\n  ", "\n  &[type=\"button\"] {\n    font-size: 0.6875em;\n    padding-block: 0.45em;\n    padding-inline: 0.625em 1em;\n  }\n\n  .icon.icon {\n    position: initial;\n    display: grid;\n    font-size: 1em;\n    margin-right: 0.5em;\n  }\n\n  span[style*=\"margin: 0px auto;\"] {\n    padding-top: 0.125em;\n  }\n"], ["\n  margin-left: 25px;\n\n  &:hover {\n    transition-delay: 100ms;\n  }\n\n  ", "\n  ", "\n  &[type=\"button\"] {\n    font-size: 0.6875em;\n    padding-block: 0.45em;\n    padding-inline: 0.625em 1em;\n  }\n\n  .icon.icon {\n    position: initial;\n    display: grid;\n    font-size: 1em;\n    margin-right: 0.5em;\n  }\n\n  span[style*=\"margin: 0px auto;\"] {\n    padding-top: 0.125em;\n  }\n"])), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled &&
        "\n    color: ".concat(theme.color.darkBlue60, ";\n    border-color: ").concat(theme.color.darkBlue60, ";\n  ");
}, function (_a) {
    var hidden = _a.hidden;
    return hidden &&
        "\n    visibility: hidden;\n  ";
});
var FlexStart = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  margin-top: 0.625em;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  margin-top: 0.625em;\n"])));
var ImagePreviewContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  border-radius: 8px;\n  color: ", ";\n  border: 1px solid ", ";\n  background-color: rgba(43, 183, 217, 0.05);\n  ", "\n"], ["\n  display: flex;\n  border-radius: 8px;\n  color: ", ";\n  border: 1px solid ", ";\n  background-color: rgba(43, 183, 217, 0.05);\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var disabled = _a.disabled;
    return disabled &&
        "\n    opacity: 0.6;\n    filter: saturate(25%);\n";
});
var EmptyMessage = styled(FlexColumn)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 1.25em 0.625em;\n  user-select: none;\n\n  @media (min-width: ", "px) {\n    height: Max(18.75rem, 18.75em);\n  }\n"], ["\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 1.25em 0.625em;\n  user-select: none;\n\n  @media (min-width: ", "px) {\n    height: Max(18.75rem, 18.75em);\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoint.lg;
});
var PaddedImage = styled.img(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 10px;\n  width: 100%;\n"], ["\n  padding: 10px;\n  width: 100%;\n"])));
var CameraGlyph = styled.svg(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 6.25em;\n  margin-bottom: 15px;\n\n  g {\n    stroke: ", ";\n  }\n\n  ~ span {\n    font-size: 1.25em;\n    text-align: center;\n  }\n"], ["\n  width: 6.25em;\n  margin-bottom: 15px;\n\n  g {\n    stroke: ", ";\n  }\n\n  ~ span {\n    font-size: 1.25em;\n    text-align: center;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
});
export var SnapshotControl = function (_a) {
    var name = _a.name, image = _a.image, disabled = _a.disabled, textSize = _a.textSize, onChange = _a.onChange, transformUrl = _a.transformUrl, onClear = _a.onClear;
    var _b = useState(null), preSignedUrl = _b[0], setPreSignedUrl = _b[1];
    // Fetch and update the AWS pre-signed URL if the input is a valid URL
    useEffect(function () {
        var fetchFileDetails = function (url) { return __awaiter(void 0, void 0, void 0, function () {
            var preSignedUrl_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getPreSignedUrl(url, transformUrl)];
                    case 1:
                        preSignedUrl_1 = _a.sent();
                        setPreSignedUrl(preSignedUrl_1);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        Alert.error("Failed to fetch pre-signed URL:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (image && isUrl(image)) {
            fetchFileDetails(image); // Fetch file details from the URL.
        }
    }, [image, transformUrl]);
    return (React.createElement(FlexStart, { style: { fontSize: "".concat(textSize, "rem") } },
        React.createElement(ClickDelegate, { disabled: disabled },
            React.createElement(ImagePreviewContainer, { disabled: disabled, "data-test-id": "".concat(name, "-preview") },
                image ? (React.createElement(PaddedImage, { src: preSignedUrl || image, alt: "Camera Preview" })) : (React.createElement(EmptyMessage, null,
                    React.createElement(CameraGlyph, { className: "image-placeholder-camera" },
                        React.createElement(CameraPlaceholder, null)),
                    React.createElement(Text, { fontSize: 4 }, "Tap here to add photo"))),
                React.createElement(FileInput, { value: "", name: name, multiple: false, acceptedMediaTypes: SUPPORTED_MEDIA_TYPE_IMAGES, disabled: disabled, onChange: onChange }))),
        image && (React.createElement(ClearButton, { outline: true, color: "danger", size: "small", icon: "close", onClick: onClear, disabled: disabled }, "Remove"))));
};
SnapshotControl.defaultProps = {
    textSize: 1,
    onChange: function () { },
    onClear: function () { },
    transformUrl: function (url) { return url; },
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
